import { css } from '@emotion/react';

const pageStyles = css`
    .page-header-edit-mode,
    .page-footer-edit-mode {
        position: relative;
        padding: 1rem 0;

        .border {
            border-bottom: 1px dotted grey;
            position: absolute;
            top: 25px;
            width: 100%;
            z-index: 0;
        }

        span {
            background-color: white;
            border: 1px solid grey;
            border-radius: 5px;
            margin-left: 1rem;
            position: relative;
            z-index: 1;
            padding: 0px 5px;
        }
    }

    .page-layout {
        .two-column {
            display: flex;
            justify-content: space-between;
        }
    }
`;

export default pageStyles;
